import 'jquery';
import * as Highcharts from 'highcharts';
import 'es6-promise/auto';
import SimpleBar from 'simplebar';
import { Amplitude } from '../Shared/amplitude';
import { Navigation } from '../Shared/navigation';
import { Charts } from './charts';
import initCarousel from './carousel';
import UnreadIndicator from './unread-indicator';

import initDataTables from './data-tables';
//import 'datatables.net';
//import 'datatables.net-bs4';
//import '../dataTables.bootstrap4.css';

function updateCharts(investor: number | null, charts: HighchartsOptionsMap, cohortYear: number | null, excludeExits: boolean | null, provider: number | null = null) {
	return new Promise(resolve => {
		$.ajax({
			type: "POST",
			url: "/api/chart?investor=" + investor,
			data: JSON.stringify({
				investor: investor,
				fields: Object.keys(charts),
				cohortYear: cohortYear,
				excludeExits: excludeExits,
				provider: provider
			}),
			contentType: "application/json",
			dataType: "json",
			success: function (chartData: HighchartsOptionsMap) {
				for (let field in charts) {
					var chart = Highcharts.chart(field + "-chart", $.extend(true, {}, charts[field], chartData[field]));

					var table = $("table#" + field + "-table");
					var tbody = table.append("<tbody></tbody>");

					var series = chart.series[0];
					for (var pts of series.data) {
						var val = pts.y.toLocaleString("en-us", {
							style: "currency",
							currency: "USD",
							minimumFractionDigits: 0,
							maximumFractionDigits: 0
						});
						tbody.append("<tr><td><span class='chart-dot' style='background-color:" + charts[field].colors[pts.index] + "'></span>" + pts.name + "</td><td>" + val + "</td></tr>");
					}
					resolve();
				}
			}
		});
	});
}

interface HighchartsOptionsMap { [field: string]: Highcharts.Options; };

async function updateMiniCharts(investor: number | null, charts: HighchartsOptionsMap, cohortYear: number | null, excludeExits: boolean | null, provider: number | null = null) {
	return new Promise(resolve => {
		$.ajax({
			type: "POST",
			url: "/api/chart/mini?investor=" + investor,
			data: JSON.stringify({
				investor: investor,
				fields: Object.keys(charts),
				cohortYear: cohortYear,
				excludeExits: excludeExits,
				provider: provider
			}),
			contentType: "application/json",
			dataType: "json",
			success: function (chartData: HighchartsOptionsMap) {
				for (let field in charts) {
					var chartId = field + "-minichart";

					if (document.getElementById(chartId))
						Highcharts.chart(chartId, $.extend(true, {}, charts[field], chartData[field]));
				}
				resolve();
			}
		});
	});
};

export function loadCharts(investor: number | null, cohortYear: number | null = null, excludeExits: boolean | null = null, provider: number | null = null) {
	updateMiniCharts(investor, {
		"value": Charts.MiniChart,
		"total": Charts.MiniChart,
		"return": Charts.MiniChartLine
	}, cohortYear, excludeExits, provider).then(value => {
		updateCharts(investor, {
			"currency": Charts.CategoryPie,
			"jurisdiction": Charts.CategoryPie,
			"sector": Charts.CategoryPie,
			"market": Charts.CategoryPie,
			"stage": Charts.CategoryPie
		}, cohortYear, excludeExits, provider);
	});
}

function loadPortfolioStructureChart(investor: number | null, cohortYear: number | null = null, excludeExits: boolean | null = null, provider: number | null = null) {
	if ($('#portfolio-structure-chart').length === 0)
		return;

	const endpoint = "/api/chart/portfolio?investor=" + investor + "&cohortYear=" + cohortYear + "&excludeExits=" + excludeExits + "&provider=" + provider;

	$.get(endpoint, function (chartData: any) {
		Highcharts.chart('portfolio-structure-chart', $.extend(true, {}, Charts.PortfolioStream, chartData));
	});
};

export function loadMiniChart(investor: number | null, chart: string, cohortYear: number | null = null, excludeExits: boolean | null = null, provider: number | null = null) {
	let charts: HighchartsOptionsMap = {};

	switch (chart) {
		case "return":
			charts[chart] = Charts.MiniChartLine;
			break;
		case "value":
		case "total":
		default:
			charts[chart] = Charts.MiniChart;
			break;
	}
	updateMiniCharts(investor, charts, cohortYear, excludeExits, provider);
}

function adjustInvestorDashboardHeight() {
	if (window.innerHeight < 660)
		return;

	const $investorPortfolio = $('.my-portfolio.investor-portfolio');

	if (document.body.clientWidth > 960) {
		const $mainSection = $('main');
		const $investmentOpportunitiesBlock = $mainSection.find('.investment-opportunities-block');
		const $reportBlock = $mainSection.find('.report-block');

		const mainSectionPadding = ($mainSection.outerHeight() - $mainSection.height()) / 2;
		const siteNavigationHeight = $('.site-navigation').outerHeight();
		let reportBlockHeight = 0;
		let opportunitiesBlockHeight = 0;

		if ($investmentOpportunitiesBlock.length) {
			opportunitiesBlockHeight = $investmentOpportunitiesBlock.outerHeight() + mainSectionPadding;
		}

		if ($reportBlock.length) {
			reportBlockHeight = $reportBlock.outerHeight();
		}

		$investorPortfolio.height(window.innerHeight - siteNavigationHeight - mainSectionPadding - opportunitiesBlockHeight - reportBlockHeight - mainSectionPadding);
	}
	else {
		$investorPortfolio.height('');
	}
}

function initUploadPortfolioForm() {
	const $form = $('#upload-portfolio-form');
	const $inputFiles = $form.find('#upload-portfolio-file');

	$form.find('#upload-portfolio-btn').click(function () {
		$inputFiles.click();
	});

	$inputFiles.on('change', function () {
		const fileData = $inputFiles.prop('files')[0];
		const formData = new FormData();
		formData.append('portfolio', fileData);

		$.ajax({
			url: $form.attr('action'),
			dataType: 'text',
			cache: false,
			contentType: false,
			processData: false,
			data: formData,
			type: 'post',
			success: function (response) {
				Navigation.reload();
			},
			error: function (jXHR, textStatus, errorThrown) {
				const $errorMessage = $('<div>').addClass('alert alert-danger alert-dismissible')
					.text(jXHR.responseText)
					.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
				$form.prepend($errorMessage);
			}
		});
	});
}

interface PortfolioFilter {
	cohortYear: number,
	excludeExits: boolean,
	providerName: string,
	providerUrl: string
}

function getPortfolioFilter(): PortfolioFilter {
	const $filterForm = $('#portfolio-summary-filter');
	const $providerFilter = $filterForm.find('#provider-select option:selected');

	return <PortfolioFilter>{
		cohortYear: $filterForm.find('#cohort-year-select option:selected').val() as number | null,
		excludeExits: $filterForm.find('.exclude-exits-controls input:checked').val() == 'true' ? true : null,
		providerName: $providerFilter.text(),
		providerUrl: $providerFilter.val() as string
	};
}

function getPortfolioUrl(filter: PortfolioFilter): string {
	if (!filter)
		return;

	let url = $('#portfolio-summary-filter').attr('action');

	if (filter.providerUrl) {
		url = filter.providerUrl;
	}
	else {
		const role = $('#role').val() as string
		if (role)
			url = role;
	}

	if (filter.cohortYear) {
		if (url.indexOf('?') > -1) {
			url += '&cohortYear=' + filter.cohortYear;
		}
		else {
			url += '?cohortYear=' + filter.cohortYear;
		}
	}

	if (filter.excludeExits) {
		if (url.indexOf('?') > -1) {
			url += '&excludeExits=' + filter.excludeExits;
		}
		else {
			url += '?excludeExits=' + filter.excludeExits;
		}
	}

	if (window.location.hash) {
		url += window.location.hash;
	}

	return url;
}

function onLoad() {
	const scope = $('#scope').val();
	const scopePortfolioView = $('#scope-portfolio-view').val();

	if (scope !== 'portfolio')
		return;

	Amplitude.logEvent('Portfolio - View');

	if (scopePortfolioView === 'investor') {
		adjustInvestorDashboardHeight();
		window.onresize = adjustInvestorDashboardHeight;

		var unreadIndicator = new UnreadIndicator();

		initCarousel('#my-portfolio-carousel', 'Portfolio', function (hash: string) {
			if (hash === '#Highlights') {
				unreadIndicator.startTracking('highlights', function () {
					$('.unread-indicator--highlights').remove();
				});
			}
			else {
				unreadIndicator.stopTracking('highlights');
			}
		});
	}
	else {
		initCarousel('#my-portfolio-carousel', 'Portfolio');
	}

	const investorKey = $('#investor-key').val() as number | null;
	const providerKey = $('#provider-key').val() as number | null;
	const portfolioFilter = getPortfolioFilter();

	initDataTables();
	loadCharts(investorKey, portfolioFilter.cohortYear, portfolioFilter.excludeExits, providerKey);
	loadPortfolioStructureChart(investorKey, portfolioFilter.cohortYear, portfolioFilter.excludeExits, providerKey);
	initUploadPortfolioForm();

	$('.my-portfolio').find('.portfolio-project-link').click(function (e) {
		e.preventDefault();

		const $this = $(this);
		$this.tooltip('hide');

		const href = $this.attr('href');
		Navigation.visit(href);
	});

	const $filterForm = $('#portfolio-summary-filter');
	const $providerSelect = $('#provider-select');

	$providerSelect.on('change', function () {
		const $this = $(this);

		const path = $this.val() as string;
		Navigation.visit(path);

		Amplitude.logEvent('Portfolio - Filter', {
			'Provider Filter': $this.text()
		});
	});

	$filterForm.find('#cohort-year-select, .exclude-exits-control input').on('change', () => {
		const filter = getPortfolioFilter();
		const path = getPortfolioUrl(filter);

		Navigation.visit(path);
		Amplitude.logEvent('Portfolio - Filter', {
			'CohortYear': filter.cohortYear,
			'ExcludeExits': filter.excludeExits,
			'Provider': filter.providerName
		});
	});

	$('[data-toggle="tooltip"]').tooltip();
	$('.summary .hint-tooltip').tooltip();
}

$(() => {
	onLoad();
	document.addEventListener("turbolinks:load", onLoad);
});